var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"cent"},[_c('topinfo'),_c('navbar'),_c('Carousel'),_c('infobar',{attrs:{"info":_vm.homeinfo}}),_c('botinfo')],1),_c('backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }